<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Time Off Ledgers</p>
      </div>
      <div class="flex justify-between items-center p-2">
        <div class="flex justify-between gap-8">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          >
          </el-pagination>
          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
        </div>
        <div class="flex flex-wrap whitespace-nowrap gap-2">
          <el-dropdown>
            <el-button type="warning">
              Close/Open<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><el-button
                  @click="handlePeriodClose"
                  type="warning"
                  style="width: 100%"
                  >Close December</el-button
                ></el-dropdown-item
              >
              <el-dropdown-item
                ><el-button
                  @click="handlePeriodOpen"
                  type="warning"
                  style="width: 100%"
                  >Open January</el-button
                ></el-dropdown-item
              >
              <el-dropdown-item
                ><el-button
                  @click="handleCarryForward"
                  type="warning"
                  style="width: 100%"
                  >Carry Forward</el-button
                ></el-dropdown-item
              >
              <el-dropdown-item
                ><el-button
                  @click="handleDownloadLedger"
                  type="warning"
                  style="width: 100%"
                  >Download Ledger</el-button
                ></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <button
            @click="showBulkUpload = true"
            class="border-1.5 rounded-full p-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Import
          </button>
          <button
            @click="exportTemplate"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Export
          </button>
        </div>
      </div>
      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>
          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Leave Types found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateTimeoffJournal
      @close="handleClose"
      :showCreateTimeoffJournal="showCreateTimeoffJournal"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
    ></CreateTimeoffJournal>

    <!-- edit -->
    <EditLeaveType
      @close="handleClose"
      :leaveTypeToEdit="leaveTypeToEdit"
      :info="info"
      :showEditLeaveType="showEditLeaveType"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </EditLeaveType>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>

    <!-- Create multiple ledger entries -->
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      title="Upload Timeoff Ledger"
      dataType="UploadTimeoffLedger"
      :url="url"
      :dateColumns="['TimeoffPeriod', 'StartDate', 'EndDate']"
      :columns="timeoffLedgersBulkUploadColumns"
    ></BulkUpload>
    <PeriodOptions
      :title="actionTitle"
      :close="close"
      :showOption="showOption"
      :selectPeriodCallback="selectPeriodCallback"
    />
    <ExportOptions
      :show-export-options="showExportOptions"
      :leave-names="leaveNames"
      :activeLeaveName="activeTab"
      :exportLeaveDatacallBack="exportLeaveDatacallBack"
      :close="close"
    ></ExportOptions>
  </div>
</template>

<script>
import axios from "axios";
import CreateTimeoffJournal from "@/components/CompanySetups/timeOffSetups/create.vue";
import EditLeaveType from "@/components/CompanySetups/leaveTypes/editLeaveType.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import ExportOptions from "@/components/timeoff/exportOptions.vue";

import { mapGetters } from "vuex";
import timeoffLedgersBulkUploadColumns from "@/data/timeoffLedgersBulkUploadColumns";
import PeriodOptions from "./periodOptions.vue";

import moment from "moment";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import { utils, writeFileXLSX } from "xlsx";
import decryptData from "@/utils/decrypt";
// import Switches from 'vue-switches';
export default {
  name: "timeOffJournalsList",
  components: {
    Loader,
    CreateTimeoffJournal,
    EditLeaveType,
    ActionWarning,
    PeriodOptions,
    ExportOptions,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
  },

  data() {
    return {
      url: `/timeoff/ledger/bulk/${this.$ApiVersion}/upload`,
      showExportOptions: false,
      actionTitle: "",
      leaveNames: [],
      activeTab: "",
      filteredLedgersData: {},
      timeoffLedgersBulkUploadColumns: null,
      showBulkUpload: false,
      showCreateTimeoffJournal: false,
      showEditLeaveType: false,
      loading: false,
      showOption: false,
      get_error: null,
      create_success: "Leave Type created successfully",
      del_loca: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      leaveTypeToDelete: null,
      showWarning: false,
      leaveTypeToEdit: {},
      setIsConfirmed: false,
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Type",
          key: "type",
          title: "Type",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => row.Type.split(/(?=[A-Z])/).join(" "),
          sampleValue: "Brought Forward",
        },
        {
          field: "TimeoffJournalName",
          key: "TimeoffJournalName",
          title: "Timeoff Journal",
          headerAlign: "left",
          align: "left",
          sampleValue: "Existing Employees",
        },
        {
          field: "LeaveTypeName",
          key: "leavetypeid",
          title: "Timeoff Type",
          headerAlign: "left",
          align: "left",
          sampleValue: "Annual",
        },

        {
          field: "EmployeeId",
          key: "EmployeeId",
          title: "Employee No",
          headerAlign: "left",
          align: "left",
          sampleValue: "EMPLOYEE-01",
        },

        {
          field: "EmployeeName",
          key: "EmployeeName",
          title: "Employee",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            decryptData(row.EmployeeName, this.$decryptionKey),
        },

        {
          field: "LeavePeriodName",
          key: "leaveperiodid",
          title: "Timeoff Period",
          headerAlign: "center",
          align: "left",

          sampleValue: "January",
        },
        {
          field: "Days",
          key: "days",
          title: "Days",
          headerAlign: "center",
          align: "center",
          sampleValue: "0.5",
        },
        {
          field: "StartDate",
          key: "StartDate",
          title: "Start Date",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) =>
            moment(row.StartDate).format("DD/MM/YYYY"),
          sampleValue: "01/08/2023",
        },
        {
          field: "EndDate",
          key: "EndDate",
          title: "End Date",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => moment(row.EndDate).format("DD/MM/YYYY"),
          sampleValue: "31/08/2023",
        },
        {
          field: "Created",
          key: "Created",
          title: "Date Created",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => moment(row.Created).format("DD/MM/YYYY"),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            let propertyValue = item[key];

            // Decrypt EmployeeName property if key is EmployeeName
            if (key === "EmployeeName") {
              propertyValue = decryptData(propertyValue, this.$decryptionKey);
            }

            if (
              propertyValue?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.timeoffLedgersBulkUploadColumns = timeoffLedgersBulkUploadColumns;
    this.getLedgerEntries();
    this.setPageSizes();
    this.getLeaveTypes();
  },
  methods: {
    reload() {
      this.getLedgerEntries();
    },
    async getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
          options
        );

        this.loading = false;

        if (response.data.StatusCode === 200) {
          this.leaveTypes = response.data.Data;
          this.leaveTypeIds = this.leaveTypes.map((leave) => leave.Id);
          this.leaveNames = this.leaveTypes.map((leave) => leave.Name);
          this.activeTab = this.leaveNames[0];
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },
    exportData(leaveNames, selectedEmployee) {
      const wb = utils.book_new();
      leaveNames.forEach((leaveName) => {
        let ledgerData = this.filteredLedgersData[leaveName];
        let ws;

        ledgerData = ledgerData.map((obj) => {
          const { TimeoffJournalId, LeaveTypeId, LeavePeriodId, Id, ...rest } =
            obj;
          rest["StartDate"] = moment(rest.StartDate).format(
            "DD/MM/YYY hh:mm:ss a"
          );
          rest["EndDate"] = moment(rest.EndDate).format("DD/MM/YYY hh:mm:ss a");
          rest["Created"] = moment(rest.Created).format("DD/MM/YYY hh:mm:ss a");
          TimeoffJournalId, LeaveTypeId, LeavePeriodId, Id;
          return rest;
        });

        if (selectedEmployee) {
          ledgerData = ledgerData.filter(
            (ledger) => ledger.EmployeeId === selectedEmployee
          );
          ws = utils.json_to_sheet(ledgerData);
        } else {
          ws = utils.json_to_sheet(ledgerData);
        }

        utils.book_append_sheet(wb, ws, leaveName);
      });

      writeFileXLSX(
        wb,
        `${
          leaveNames.length <= 1 ? `${leaveNames[0]} Ledger` : "Leave Ledger"
        }.xlsx`
      );
    },
    filterLedgers() {
      this.leaveNames.forEach((leaveName) => {
        const filteredLedgers = this.tableData
          .filter((leave) => leave.LeaveTypeName.includes(leaveName))
          .map(({ Summary, ...rest }) => ({
            ...rest,
            ...Summary,
          }));

        this.filteredLedgersData[leaveName] = filteredLedgers;
      });
      this.loading = false;
    },
    exportLeaveDatacallBack(data, selectedEmployee = null) {
      this.exportData(data, selectedEmployee);
    },
    handlePeriodClose() {
      this.showOption = true;

      this.actionTitle = "Close Period";
    },
    handlePeriodOpen() {
      this.showOption = true;

      this.actionTitle = "Open Period";
    },
    handleCarryForward() {
      this.showOption = true;

      this.actionTitle = "Carry Forward";
    },
    handleDownloadLedger() {
      this.showExportOptions = true;
      this.actionTitle = "Download Ledger";
    },
    close() {
      this.showExportOptions = false;
      this.showOption = false;
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
      this.getLedgerEntries();
    },

    // The callback function for the action
    selectPeriodCallback(fromPeriod, toPeriod = null) {
      switch (this.actionTitle) {
        case "Close Period":
          this.closeTimeoffPeriod("december", fromPeriod.Id);
          break;

        case "Open Period":
          this.openTimeoffPeriod("january", fromPeriod.Id);
          break;

        case "Carry Forward":
          if (toPeriod) {
            // If toPeriod is provided, use it as the second argument
            this.carryForwardPeriod(fromPeriod.Id, toPeriod.Id);
          }
          break;

        default:
          break;
      }
    },
    async closeTimeoffPeriod(month, periodId) {
      const url = `${this.getOrganization}/setup/timeoff/closing/v1/${month}?periodId=${periodId}`;
      this.loading = true;
      const options = {
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.post(url, "", options);

        if (response.data.StatusCode === 200) {
          this.loading = false;
          // Handle successful response
          this.$notify({
            title: "Success",
            message: response.data.StatusMessage,
            type: "success",
          });
          this.showOption = false;
          this.getLedgerEntries();
        } else {
          // Handle error response
          this.$notify.error({
            title: "Failure",
            message: `${response.data.StatusMessage}`,
          });
        }
      } catch (error) {
        // Handle network or request error

        this.$notify.error({
          title: "Failure",
          message: `${error.message}`,
        });
      }
    },
    async openTimeoffPeriod(month, periodId) {
      const url = `${this.getOrganization}/setup/timeoff/opening/v1/${month}?periodId=${periodId}`;
      this.loading = true;
      const options = {
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.post(url, "", options);

        if (response.data.StatusCode === 200) {
          this.loading = false;
          // Handle successful response
          this.$notify({
            title: "Success",
            message: response.data.StatusMessage,
            type: "success",
          });
          this.showOption = false;
          this.getLedgerEntries();
        } else {
          // Handle error response
          this.$notify.error({
            title: "Failure",
            message: `${response.data.StatusMessage}`,
          });
        }
      } catch (error) {
        // Handle network or request error
        this.$notify.error({
          title: "Failure",
          message: `${error.message}`,
        });
      }
    },
    // https://api.talantahrm.com/dataposit/setup/timeoff/v1/carryforward?fromPeriodId=34567890DFGFGHJK&toPeriodId=R345678FEGHJ

    async carryForwardPeriod(fromPeriodId, toPeriodId) {
      const url = `${this.getOrganization}/setup/timeoff/v1/carryforward?fromPeriodId=${fromPeriodId}&toPeriodId=${toPeriodId}`;

      const options = {
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.post(url, "", options);

        if (response.data.StatusCode === 200) {
          // Handle successful response
          this.$notify({
            title: "Success",
            message: response.data.StatusMessage,
            type: "success",
          });
          this.getLedgerEntries();
        } else {
          // Handle error response
          this.$notify.error({
            title: "Failure",
            message: `${response.data.StatusMessage}`,
          });
        }
      } catch (error) {
        // Handle network or request error
        this.$notify.error({
          title: "Failure",
          message: `${error.message}`,
        });
      }
    },

    exportTemplate() {
      let templateColumns = [
        ...this.columns.filter(
          (n) =>
            n.title !== "#" &&
            n.field !== "EmployeeName" &&
            n.field !== "Created" &&
            n.field !== "LeavePeriodName"
        ),
      ];

      importTemplateGenerator(
        templateColumns,
        "TimeoffLedgers",
        [],
        false,
        false
      );
    },
    handleClose() {
      this.showCreateTimeoffJournal = false;
      this.showEditLeaveType = false;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleCloseOnSuccess() {
      this.showCreateTimeoffJournal = false;
      this.showLocCrSuccess = false;
      this.showEditLeaveType = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getLedgerEntries();
    },

    // /{organization}/timeoff/ledger/v1/request
    getLedgerEntries() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/timeoff/ledger/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
              this.filterLedgers();
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
